/**
 * Nested-IA alias route — round 4 / #228.
 *
 * Mounts the API connection wizard at `/connections/api/new` so the
 * Codex full-baseline IA inventory resolves. The flat route at
 * `/connections/new-api` continues to work — this is an alias, not a
 * migration — so existing internal links don't break.
 *
 * The page component is the canonical implementation in `new-api.tsx`;
 * this file does nothing but register the additional URL.
 */

import { createFileRoute } from '@tanstack/react-router';
import { NewApiPage } from './new-api';

export const Route = createFileRoute('/connections/api/new')({
  component: NewApiPage,
});
